import React, { useEffect, useRef } from 'react'
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Header from '../landing/Header/Header';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const Bannerchatandrepay = () => {
  const textRef = useRef(null);
  const paraRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    const tl = gsap.timeline();

    gsap.set(textRef.current, {
      clipPath: "inset(0% 100% 0% 0%)",
      opacity: 1,
    });

    tl.to(textRef.current, {
      clipPath: "inset(0% 0% 0% 0%)",
      duration: 1,
      ease: "power2.out",
    });
  }, []);

  useEffect(() => {
    gsap.fromTo(
      paraRef.current,
      { opacity: 0, y: 50 },
      { opacity: 1, y: 0, duration: 1, ease: "power2.out" }
    );
  }, []);

  useEffect(() => {
    const tl = gsap.timeline();

    gsap.set(buttonRef.current, {
      clipPath: "inset(0% 100% 0% 0%)",
      opacity: 1,
    });


    tl.to(buttonRef.current, {
      clipPath: "inset(0% 0% 0% 0%)",
      duration: 0.5,
      ease: "power2.out",
    })

      .to(buttonRef.current, {
        rotateY: 360,
        duration: 0.8,
        ease: "power2.inOut",
      });
  }, []);

  useEffect(() => {
    gsap.from(".breadvrumbcnt, .breadvrumbcntactive", {
      opacity: 0,
      y: 10,
      duration: 0.6,
      stagger: 0.2,
      ease: "power2.out",
    });
  }, []);

  useEffect(() => {
    gsap.fromTo(".fade-element", { x: 100, opacity: 0, }, { x: 0, opacity: 1, duration: 1 });
  }, []);

  const breadcrumbSchema = {
    "@context": "https://schema.org/",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://tomi.com/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Browse securely", // ✅ Level 2 in JSON
        "item": "https://tomi.com/browsesecurely"
      }
    ]
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.innerHTML = JSON.stringify(breadcrumbSchema);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);


  return (
    <>
      <section className="bannermainprnt">
        <Header />
        <div className="custom-container ">

          <div className="heromain">
            <div className="heroleftseaction">
              <div className="textherobanner securlybannerthird">
                <nav aria-label="breadcrumb">
                  <Breadcrumb className="breadcrumbprnt">
                    <Breadcrumb.Item className="breadvrumbcnt" href="/">
                      Home
                    </Breadcrumb.Item>
                    <Breadcrumb.Item className="breadvrumbcnt" href="/feature">
                      Features
                    </Breadcrumb.Item>
                    <Breadcrumb.Item
                      className="breadvrumbcntactive"
                    >
                      Browse securely
                    </Breadcrumb.Item>
                  </Breadcrumb>
                </nav>
                <h1 className='browssecurlybannerheading' ref={textRef}>Browse freely and securely, without compromising privacy</h1>
                <p ref={paraRef}>TOMI offers a private and secure browsing experience that protects your data, blocks intrusive ads, and ensures your online activity remains yours. Enjoy freedom without compromising speed or usability.</p>

              </div>
              <button ref={buttonRef} data-bs-toggle="modal"
                data-bs-target="#exampleModal" className="herofeaturebannerbtn primerybtn">
                Get Early Access
              </button>
            </div>
            <div className="herorightseaction">
              <img className="img-fluid fade-element" src="\assets\Browse\Browslandingbannerimg.png" alt="img" />
            </div>
          </div>
        </div>
      </section >
    </>
  )
}

export default Bannerchatandrepay